// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import {
    Autocomplete,
    CardContent,
    Divider,
    FormControl,
    IconButton,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2";
import Button from '@mui/material/Button'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(45, 'days').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().format('YYYY-MM-DD'))

    const [valCustomer, setValCustomer] = useState<any>(null)
    const [listCustomer, setListCustomer] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getCustomer()
    }, [])

    const navigate = useNavigate();

    const getCustomer = () => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/get-customer'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListCustomer(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getData = async () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        try {
            let url = apiUrl.apiUrl + '/acc/laporan-keuangan/kartu-piutang'

            const response = await axios.get(url, {
                params: {
                    sdcust_id: valCustomer?.id,
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                },
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response.data.success) {
                setListData(
                    response.data.data.map((item, index) => ({
                        id: index + 1,
                        ...item
                    }))
                )

                Swal.close()
            } else {
                Swal.close()
                showToast(response.data.message, 'error')
            }
        } catch (err) {
            console.error(err)
        }
    }

    const handleChangeCustomer = (event: SyntheticEvent, newValue: any | null) => {
        setValCustomer(newValue)
    }

    const convertComponent = [
        {
            key: 'dokumen',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                            window.open(`${row.data.link_dokumen}`, '_blank')
                        }}>
                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                {row.data.dokumen}
                            </Typography>
                        </div>
                    </Box>
                )
            }
        },
    ];

    return (

        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='KARTU PIUTANG' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    value={valCustomer}
                                    options={listCustomer}
                                    id='customer'
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeCustomer}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.nama}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.nama}
                                    renderInput={params => (
                                        <FormControl fullWidth>
                                            <TextField
                                                {...params}
                                                label='Customer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData()}
                                        disabled={valCustomer == null ? true : false}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <MsiDatagrid
                            array={listData}
                            convertRupiah={[
                                'debet', 'kredit'
                            ]}
                            hiddenColumns={['link_dokumen', 'id']}
                            customRender={convertComponent}
                        />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}
